module.exports = __webpack_public_path__ + "static/media/icone_logout.ba46f43f.svg";